import { createSelector } from 'reselect';
import { getUserReducer } from '../selectorIndex';
import { UserReducerType } from './reducer';

export const getUser = createSelector(
    [getUserReducer],
    (userReducer: UserReducerType) => userReducer.user
);
